import { createStore } from "redux";
import rootReducer from "./combinereducer";

// import { createLogger } from 'redux-logger';
// const loggerMiddleware = createLogger()

const stores = createStore(rootReducer);
export default stores;
